module.exports = __webpack_public_path__ + "static/media/menuChart.c1a430a8.svg";